import { SetupNotifications } from "./SetupNotifications";

export default SetupNotifications;
